import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageTransition } from '../components/PageTransition';
import { Tent, Croissant, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export const Landing = () => {
  const navigate = useNavigate();
  const {
    t
  } = useLanguage();
  return <PageTransition className="justify-center p-6 text-center" data-id="element-118">
      <div className="flex-1 flex flex-col items-center justify-center max-w-sm mx-auto w-full" data-id="element-119">
        <div className="w-24 h-24 bg-white rounded-full shadow-soft flex items-center justify-center mb-8 relative" data-id="element-120">
          <Croissant className="text-terracotta w-10 h-10 absolute -ml-4 -mt-2" data-id="element-121" />
          <Tent className="text-espresso-light w-10 h-10 absolute ml-4 mt-4 opacity-80" data-id="element-122" />
        </div>

        <h1 className="text-4xl font-serif text-espresso mb-4 leading-tight" data-id="element-123">
          Top Notch Bakery
        </h1>

        <div className="flex items-center justify-center gap-2 mb-6 text-terracotta font-medium tracking-wide text-sm uppercase" data-id="element-124">
          <span className="w-8 h-[1px] bg-terracotta/40" data-id="element-125"></span>
          {t('landing.subtitle')}
          <span className="w-8 h-[1px] bg-terracotta/40" data-id="element-126"></span>
        </div>

        <p className="text-espresso-light mb-12 leading-relaxed text-lg" data-id="element-127">
          {t('landing.intro')}
        </p>

        <button onClick={() => navigate('/pickup')} className="w-full bg-espresso hover:bg-espresso-light text-white rounded-2xl p-4 font-medium flex items-center justify-center gap-2 transition-colors active:scale-[0.98]" data-id="element-128">
          {t('landing.cta')}
          <ArrowRight size={18} data-id="element-129" />
        </button>
      </div>
    </PageTransition>;
};